import { getLocales } from 'assets/locales/Locale';
import { usePublicCreateClaimProvider } from '../Hooks';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';

export default function PublicCreateClaimClaimInfo() {
  const { lang } = getLocales();
  const publicCreateClaim = usePublicCreateClaimProvider();

  const form = publicCreateClaim.form;
  return (
    <>
      <h2>{lang.claimInfoTitle}</h2>
      <p>{lang.claimInfoParagraph}.</p>

      <FormWrapper style={{ padding: '0 !important' }}>
        <InputWrapper>
          <NumberInput
            name="odometerReading"
            label={lang.odometerReading}
            error={form.errors?.claim?.odometerReading}
            value={form.data?.claim?.odometerReading}
            onChange={({ odometerReading }) => {
              form.merge({
                claim: {
                  odometerReading: odometerReading ?? undefined,
                },
              });
            }}
          />
          <TextInput
            name="workOrderNumber"
            label={lang.workOrderNumber}
            error={form.errors?.claim?.workOrderNumber}
            value={form.data?.claim?.workOrderNumber ?? ''}
            style={{ width: '100%' }}
            onChange={({ workOrderNumber }) => {
              form.merge({
                claim: { workOrderNumber },
              });
            }}
          />
        </InputWrapper>
        <MultilineTextInput
          name="descriptionOfDamage"
          label={lang.descriptionOfDamage}
          error={form.errors?.claim?.descriptionOfDamage}
          value={form.data?.claim?.descriptionOfDamage}
          onChange={({ descriptionOfDamage }) => {
            form.merge({
              claim: {
                descriptionOfDamage: descriptionOfDamage ?? undefined,
              },
            });
          }}
        />
        <InputWrapper>
          <DateInput
            name="incidentLocalDate"
            label={lang.incidentLocalDate}
            error={form.errors?.claim?.incidentLocalDate}
            value={form.data?.claim?.incidentLocalDate ?? ''}
            style={{ width: '100%' }}
            onChange={({ incidentLocalDate }) => {
              form.merge({
                claim: { incidentLocalDate },
              });
            }}
          />
          <CheckInput
            name="isVehicleInoperable"
            class={inputStyles.check.switch}
            label={lang.isVehicleInoperable}
            error={form.errors?.claim?.isVehicleInoperable}
            value={form.data?.claim?.isVehicleInoperable ?? false}
            style={{ width: '100%' }}
            onChange={({ isVehicleInoperable }) => {
              form.merge({
                claim: { isVehicleInoperable: !!isVehicleInoperable },
              });
            }}
          />
        </InputWrapper>
      </FormWrapper>
    </>
  );
}
